import React from 'react';
import styled from 'styled-components';

import { Animation, ListTile } from 'components';
import { DeleteDialogue } from 'features'
import { AnimatePresence } from 'framer-motion';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';

const Container = styled.div`
    width: max-content;
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    border: 1px solid var(--primary-accent-color);
    overflow: hidden;
    margin: 0.3rem 0;
    padding: 0.5rem;
    background-color: var(--primary-color);
`

const Tile = styled.div`
    background-color: var(--primary-color);
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 5px;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const tileStyle = {
    backgroundColor: 'var(--primary-color)'
}

const Options = props => {
    const {
        workflow,
        onEdit,
        onDelete,
        closeHandler
    } = props;
    const [showDelete, toggleDelete] = React.useState(false)
    console.log({workflow})

    return (
        <Container>
            <ListTile text='Edit workflow' icon={<FaEdit/>} onSelect={onEdit} styles={tileStyle}/>
            <ListTile text='Delete workflow' icon={<FaTrashAlt/>} onSelect={() => toggleDelete(true)} styles={tileStyle}/>
            <AnimatePresence>
                {showDelete &&
                <Animation animation='slideLeft'>
                    <DeleteDialogue 
                        checkbox={true}
                        styles={{backgroundColor: 'var(--primary-color)', titleSize: '0.8rem'}}
                        onDelete={(checked) => {
                            onDelete(checked)
                            typeof closeHandler === 'function' && closeHandler()
                        }}
                        closeHandler={() => toggleDelete(false)}/>
                </Animation>}
            </AnimatePresence>
        </Container>
    )
}

export default Options